import React from 'react';
import AceEditor from 'react-ace';

import 'ace-builds/src-noconflict/mode-mysql';
import 'ace-builds/src-noconflict/theme-github';
import langTools from 'ace-builds/src-noconflict/ext-language_tools';

import * as Styled from './styled';

const SqlEditor: React.FC<
  React.HTMLProps<HTMLDivElement> & {
    value?: string;
    schema?: any;
    onQueryChange: (sql: string) => void;
    readOnly?: boolean;
  }
> = ({ value, schema, onQueryChange, readOnly, ...rest }) => {
  const autoCompleteWordList =
    schema?.fields?.map((field: any) => ({
      caption: field.name,
      value: field.name,
      meta: field.dtype,
    })) || [];

  autoCompleteWordList.push({ caption: 'df', value: 'df', meta: 'Table' });

  const staticWordCompleter = {
    getCompletions: function (editor: any, session: any, pos: any, prefix: any, callback: any) {
      callback(null, autoCompleteWordList);
    },
  };
  langTools.addCompleter(staticWordCompleter);

  return (
    <Styled.Editor {...rest}>
      <AceEditor
        mode="mysql"
        theme="textmate"
        onChange={onQueryChange}
        name="querySqlEditor"
        height="200px"
        value={value}
        width="100%"
        wrapEnabled={true}
        showPrintMargin={false}
        minLines={12}
        maxLines={12}
        editorProps={{ $blockScrolling: true }}
        onLoad={function (editor) {
          editor.renderer.setPadding(10);
          editor.renderer.setScrollMargin(10, 10, 0, 0);
          editor.focus();
          editor.navigateFileEnd();
        }}
        setOptions={{
          enableBasicAutocompletion: true,
          enableLiveAutocompletion: true,
          enableSnippets: true,
          showLineNumbers: true,
          readOnly: !!readOnly,
          tabSize: 2,
          fontSize: 12,
          fontFamily: 'var(--font-family-mono)',
        }}
      />
    </Styled.Editor>
  );
};

export default SqlEditor;
